import { useState } from "react";

export const useSearchResultModal = (messages, onOk, selectedRows) => {

    const [dialogVisible, setDialogVisible] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [confirmMessage, setConfirmMessage] = useState('')

    const cancelHandler = e => {
        setDialogVisible(false)       
    }

    const okHandler = e => {
        onOk()
        setDialogVisible(false)
        
    }

    const showDialog = () => {        
        setDialogVisible(true)
    } 

    return {dialogVisible, showDialog, cancelHandler, messages, confirmMessage, okHandler, selectedRows}

}